import {
  OMSMetricsRequestSchema,
  TotalAdjustmentByCarrierResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getTotalAdjustmentByCarrier = {
  name: "getTotalAdjustmentByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: TotalAdjustmentByCarrierResponseSchema,
};
